import * as React from "react";
import URI from "urijs";
import Routes from "routing/Routes";
import { useGetAssets } from "security-app/hooks/useAssetsAPI";
import NumberCard from "./NumberCard";
const HIGH_RISK_THRESHOLD = 75;
const assetsReplayLink = () => new URI(Routes.ALERTS.LIST).addQuery("page", 1).addQuery("layout_variant", "assets").toString();
function AssetsCounter() {
  const {
    pagination: { total }
  } = useGetAssets({ page: 1, perPage: 1 });
  const {
    pagination: { total: highRiskAssetsCount }
  } = useGetAssets({
    page: 1,
    perPage: 1,
    filters: {
      risk_score_normalized: [{ label: `>${HIGH_RISK_THRESHOLD}`, value: `>${HIGH_RISK_THRESHOLD}`, type: "text" }]
    }
  });
  return /* @__PURE__ */ React.createElement(
    NumberCard,
    {
      value: highRiskAssetsCount.toString(),
      label: "High Risk Assets",
      subLabel: `${total} total`,
      replayLink: assetsReplayLink()
    }
  );
}
export default AssetsCounter;
